// extracted by mini-css-extract-plugin
export default {"empty":"Empty_empty__tRuN5"};